import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";

import Header from "./components/commen/Header";
import ScrollToTop from "./components/commen/ScrollToTop";
import Footer from "./components/commen/Footer";

import Home from "./pages/Home";
import AboutUs from "./pages/About-Us";
import MeetOurTeam from "./pages/Meet-our";
import Career from "./pages/Career";
import ContactUs from "./pages/Contact-Us";
import Events from "./pages/Events";
import Services from "./pages/Services";
import PrivacyPolicy from "./pages/Privecy-policy";
import TermsConditions from "./pages/Termsconditions";
import Details from "./pages/Servicesdetails/Details";

function App() {

  /* ✅ Global Language State */
  const [language, setLanguage] = useState("EN");

  return (
    <>
      <ScrollToTop />

      {/* ✅ Pass Language to Header */}
      <Header language={language} setLanguage={setLanguage} />

      <Routes>
        <Route path="/" element={<Home language={language} />} />
        <Route path="/about" element={<AboutUs language={language} />} />
        <Route path="/team" element={<MeetOurTeam language={language} />} />
        <Route path="/career" element={<Career language={language} />} />
        <Route path="/contact" element={<ContactUs language={language} />} />
        <Route path="/events" element={<Events language={language} />} />
        <Route path="/services" element={<Services language={language} />} />
        <Route path="/privacy" element={<PrivacyPolicy language={language} />} />
        <Route path="/termsconditions" element={<TermsConditions language={language} />} />
        <Route path="/services/:id" element={<Details language={language} />} />
      </Routes>

      <Footer language={language} />
    </>
  );
}

export default App;